module.exports = __webpack_public_path__ + "media/recipes/148-b37bdceb.png";